import { Route, Routes, useNavigate } from "react-router-dom";
import { useContext, useEffect, useCallback } from "react";
import Home from "./Home";
import Login from "./Components/LoginComponent/Login";
import Navigation from "./Components/NavigationComponent/Navigation";
import TopNavigation from "./Components/NavigationComponent/TopNavigation";
import Partner from "./Components/PartnerComponent/Partner";
import DeviceManagerPage from "./DeviceManager";
import UserPage from "./Components/UserComponent/User";
import HelpPage from "./Help";
import AboutPage from "./About";
import ChangePasswordPage from "./Components/ChangePasswordComponent/ChangePassword";
import Configuration from "./Components/ConfigurationComponent/Configuration";
import EditConfig from "./Components/ConfigurationComponent/EditConfiguration";
import CreateConfig from "./Components/ConfigurationComponent/AddConfiguration";
import ForceLogout from "./Components/CommonComponent/ForceLogout";
import SelectTenant from "./Components/SelectTenantComponent/SelectTenant";
import RegisterPartner from './Components/PartnerComponent/AddPartner';
import UpdatePartnerDetails from './Components/PartnerComponent/EditPartner';
import Certificate from './Components/CertificateComponent/Certificate';
import IdaCertificate from './Components/IdaCertificateComponent/IdaCertificate';
import RegisterUser from './Components/UserComponent/AddUser';
import AddRole from './Components/UserComponent/AddRole';
import AuthContext from "./Components/AuthContextComponent/AuthContext";
import NoMatch from "./Components/CommonComponent/NoMatch";
import Forbidden from "./Components/CommonComponent/Forbidden";
import Device from "./Components/DeviceComponent/Device";
import CreateDeviceDetail from "./Components/DeviceComponent/AddDevice";
import DeviceModel from "./Components/DeviceModelComponent/DeviceModel";
import UpdateDeviceDetail from "./Components/DeviceComponent/EditDevice";
import UpdateDeviceModel from "./Components/DeviceModelComponent/EditDeviceModel";
import AddDeviceModel from "./Components/DeviceModelComponent/AddDeviceModel";
import EventBus from "./Components/CommonComponent/EventBus";
import AuthenticationService from "./Services/AuthenticationService";
import "./App.css";

function App() {
    const authCtx = useContext(AuthContext);
    let navigate = useNavigate();

    const logOut = useCallback(() => {
        authCtx.logout();
        AuthenticationService.logout()
            .then(() => {
            })
            .catch((err) => {
            })
    }, []);

    useEffect(() => {
        EventBus.on("SelectTenant", () => {
            // A single-partner system never has a tenant to pick -- treat this
            // the same as any other stale-session recovery: log out and return
            // to a clean login screen instead of a picker.
            logOut();
            navigate("/login", { replace: true });
        });

        EventBus.on("Logout", () => {
            logOut();
        });

        return () => {
            EventBus.remove("SelectTenant");
            EventBus.remove("Logout");
        };
    }, [logOut]);

    // A user whose password was set by an administrator can do exactly one thing: replace it.
    // Short-circuiting above <Routes> means every URL renders this screen -- typing /Devices or any
    // other path cannot get around it. The server enforces the same rule independently, so this is
    // for UX rather than security.
    if (authCtx.isLoggedIn && authCtx.mustChangePassword) {
        return (
            <div>
                <div className="containerwithoutnavigation">
                    <ChangePasswordPage forced />
                </div>
            </div>
        );
    }

    return (
        <div>
            <div className="containerwithoutnavigation">
                <Routes>
                    <Route path="/login" element={!authCtx.isLoggedIn ? <Login /> : (authCtx.role == "Admin" ? (!authCtx.isTenantSelected ? <ForceLogout /> : <Home />) : <Home />)} />
                    <Route
                        path="/Partners"
                        element={
                            authCtx.isLoggedIn ? (
                                authCtx.role == "Admin" ?
                                    <Partner /> : <Forbidden />) : (<Login />)
                        }
                    />
                    <Route
                        path="/IdaCertificate"
                        element={
                            authCtx.isLoggedIn ? (
                                authCtx.role == "Admin" ?
                                    <IdaCertificate /> : <Forbidden />) : (<Login />)
                        }
                    />
                    <Route
                        path="/DeviceManager"
                        element={
                            authCtx.isLoggedIn ? (
                                authCtx.isTenantSelected ? (
                                    <DeviceManagerPage />
                                ) : (
                                    <ForceLogout />
                                )
                            ) : (
                                <Login />
                            )
                        }
                    />
                    <Route
                        path="/Users"
                        element={
                            authCtx.isLoggedIn ? (
                                authCtx.role == "Admin" ?
                                    <UserPage /> : <Forbidden />) : (<Login />)
                        }
                    />
                    <Route
                        path="/Certificates"
                        element={
                            authCtx.isLoggedIn ? (
                                authCtx.role == "Partner" ? (authCtx.isTenantSelected ? (
                                    <Certificate />
                                ) : (
                                    <ForceLogout />
                                )) : <Forbidden />
                            ) : (
                                <Login />
                            )
                        }
                    />
                    <Route
                        path="/Help"
                        element={
                            authCtx.isLoggedIn ? (

                                <HelpPage />
                            ) : (
                                <Login />
                            )
                        }
                    />
                    <Route
                        path="/About"
                        element={
                            authCtx.isLoggedIn ? (

                                <AboutPage />
                            ) : (
                                <Login />
                            )
                        }
                    />
                    <Route
                        path="/Devices"
                        element={
                            authCtx.isLoggedIn ? (
                                authCtx.isTenantSelected ? (
                                    <Device />
                                ) : (
                                    <ForceLogout />
                                )
                            ) : (
                                <Login />
                            )
                        }
                    />
                    <Route
                        path="/CreateDeviceDetail"
                        element={
                            authCtx.isLoggedIn ? (
                                authCtx.isTenantSelected ? (
                                    <CreateDeviceDetail />
                                ) : (
                                    <ForceLogout />
                                )
                            ) : (
                                <Login />
                            )
                        }
                    />
                    <Route
                        path="/UpdateDeviceDetail"
                        element={
                            authCtx.isLoggedIn ? (
                                authCtx.isTenantSelected ? (
                                    <UpdateDeviceDetail />
                                ) : (
                                    <ForceLogout />
                                )
                            ) : (
                                <Login />
                            )
                        }
                    />
                    <Route
                        path="/Device-Models"
                        element={
                            authCtx.isLoggedIn ? (
                                authCtx.isTenantSelected ? (
                                    <DeviceModel />
                                ) : (
                                    <ForceLogout />
                                )
                            ) : (
                                <Login />
                            )
                        }
                    />
                    <Route
                        path="/CreateDeviceModel"
                        element={
                            authCtx.isLoggedIn ? (
                                authCtx.isTenantSelected ? (
                                    <AddDeviceModel />
                                ) : (
                                    <ForceLogout />
                                )
                            ) : (
                                <Login />
                            )
                        }
                    />
                    <Route
                        path="/UpdateDeviceModel"
                        element={
                            authCtx.isLoggedIn ? (
                                authCtx.isTenantSelected ? (
                                    <UpdateDeviceModel />
                                ) : (
                                    <ForceLogout />
                                )
                            ) : (
                                <Login />
                            )
                        }
                    />
                    {/* No tenant requirement: changing your own password is tenant-independent, and
                        must work for an Admin who has no partner registered or selected yet. */}
                    <Route
                        path="/Change-password"
                        element={
                            authCtx.isLoggedIn ? (
                                <ChangePasswordPage />
                            ) : (
                                <Login />
                            )
                        }
                    />
                    <Route
                        path="/Configurations"
                        element={
                            authCtx.isLoggedIn ? (
                                authCtx.role == "Admin" ? (authCtx.isTenantSelected ? (
                                    <Configuration />
                                ) : (
                                    <ForceLogout />
                                )
                                ) : <Forbidden />
                            ) : (
                                <Login />
                            )
                        }
                    />
                    <Route
                        path="/editConfig"
                        element={
                            authCtx.isLoggedIn ? (
                                authCtx.role == "Admin" ? (authCtx.isTenantSelected ? (
                                    <EditConfig />
                                ) : (
                                    <ForceLogout />
                                )
                                ) : <Forbidden />
                            ) : (
                                <Login />
                            )
                        }
                    />
                    <Route
                        path="/createConfig"
                        element={
                            authCtx.isLoggedIn ? (
                                authCtx.role == "Admin" ? (authCtx.isTenantSelected ? (
                                    <CreateConfig />
                                ) : (
                                    <ForceLogout />
                                )) : <Forbidden />
                            ) : (
                                <Login />
                            )
                        }
                    />
                    <Route
                        path="/selectTenant"
                        element={authCtx.isLoggedIn ? (authCtx.role == "Admin" ? <SelectTenant /> : <Forbidden />) : <Login />}
                    />
                    <Route path="/registerPartner" element={authCtx.isLoggedIn ? (authCtx.role == "Admin" ? < RegisterPartner /> : <Forbidden />) : <Login />} />
                    <Route path="/updatePartnerDetails" element={authCtx.isLoggedIn ? (authCtx.role == "Admin" ? (authCtx.isTenantSelected ? < UpdatePartnerDetails /> : < ForceLogout />) : <Forbidden />) : <Login />} />
                    <Route
                        path="/selectTenantPopup"
                        element={authCtx.isLoggedIn ? (authCtx.role == "Admin" ? <ForceLogout /> : <Forbidden />) : <Login />}
                    />
                    <Route path="/registerUser" element={authCtx.isLoggedIn ? (authCtx.isTenantSelected ? < RegisterUser /> : < ForceLogout />) : <Login />} />
                    <Route path="/createRole" element={authCtx.isLoggedIn ? (authCtx.isTenantSelected ? < AddRole /> : < ForceLogout />) : <Login />} />
                    <Route
                        path="/"
                        element={
                            authCtx.isLoggedIn ? (
                                authCtx.role == "Admin" ? (authCtx.isTenantSelected ? (
                                    <Home />
                                ) : (
                                    <ForceLogout />
                                )) : <Home />
                            ) : (
                                <Login />
                            )
                        }
                    />
                    <Route path="*" element={<NoMatch />} />
                </Routes>
            </div>
        </div>
    );
}

export default App;
